import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import Modal from 'react-modal';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import reportWebVitals from './reportWebVitals';
import store from './app/store';
import AppRouter from './app/components/Router/Router';
import { MainRouter } from './main/components/Router/Router';

//
// [@fortawesome/react-fontawesome]
// FontAwesomeIcon library globally available icons.
//
library.add(fas, far);

//
// [react-modal]
// React Modal base element.
//
Modal.setAppElement('#root');

const scope = document.querySelector('meta[name="scope"]').content;

if (store.getState().theme.name === 'dark') {
  document.querySelector('body').classList.add('dark');
}

const renderApp = async () => {
  await import('@sass/app.scss');

  render(
    <Provider store={store}>
      <AppRouter />
    </Provider>,
    document.getElementById('root'),
  );
};

const renderMain = async () => {
  await import('@sass/main.scss');

  render(
    <Provider store={store}>
      <MainRouter history={createBrowserHistory()} />
    </Provider>,
    document.getElementById('root'),
  );
};

if (scope === 'app') {
  renderApp();
} else {
  renderMain();
}

reportWebVitals();
